import axios from '../../axios'
import UserStore from '@stores/UserStore'
import { IDailyStatusPrams } from './interface'

export * from './interface'

interface IParams {
  pageSize: number
  pageNo: number
}

export default {
  /**
   * 面谈列表
   */
  newFaceRecordList: (params: object) =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/probation/getMonthlyAuditStatus.do',
      {
        params,
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),

  // 获取实践列表的数据
  getPracticeListData: ({ pageNo, pageSize }: IParams) =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/queryMentorRecordPage.do',
      {
        params: {
          pageNo,
          pageSize,
        },
      }
    ),

  // 智门户个人发展计划类型-查询学员/指导人/主管身份拥有的每一行数据以及完成状态
  getEveryTypeStatus: (
    idPracticalTraining: string,
    currentRole: string
  ): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/progress/evaluation/queryProgressItemInfoByRole.do',
      {
        params: {
          idPracticalTraining,
          currentRole,
        },
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),

  // 智门户个人发展计划类型-身份查询
  queryMentorRoleList: (idPracticalTraining: string): Promise<any> =>
    axios.get(
      '/learn/app//clientapi/trainingclass/practical/progress/evaluation/queryMentorRoleList.do',
      {
        params: {
          idPracticalTraining,
        },
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),

  // 获取实践项目列表的数据
  getPracticeProjectListData: (idPracticalTraining: string): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/queryMentorTask.do',
      {
        params: {
          idPracticalTraining,
        },
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 日历展示提交状态
  getDailyStatus: (params: IDailyStatusPrams) =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/mid/showDailyStatus.do',
      {
        params,
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 周报列表
  checkWeekList: (params: object) =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/mid/mentorCheckWeekList.do',
      {
        params,
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 获取行动学习类型身份
  getActionLearnIdentity: (params: object) =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/evaluation/queryMentorRoleList.do',
      {
        params,
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 获取行动学习类型身份数据
  getActionLearnCardData: (params: object): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/evaluation/queryMentorItemInfoByRole.do',
      {
        params,
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 获取培训项目项目简介 --云校
  getCSHumanTrainingName: (trainingItemId: string): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/cloudschool/trainingItem.do',
      {
        params: {
          trainingItemId,
        },
      }
    ),

  // 获取培训项目项目简介
  getHumanTrainingName: (trainingItemId: string): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/training/item/selectItemDetailInfo.do',
      {
        params: {
          trainingItemId,
        },
      }
    ),
  // 获取培训项目项目内容
  getHumanTrainingData: (params: object): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/training/item/selectAllResourcePage.do',
      {
        params,
      }
    ),
  // 获取培训项目项目完成规则
  getRule: (trainingItemId: string): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/training/item/getTrainingItemPeriodsInfoById.do',
      {
        params: { trainingItemId },
        headers: {
          sid: UserStore.getSid(),
        },
      }
    ),
  // 获取培训项目完成规则多个考试列表 --云校
  getExamListData: (params: object): Promise<any> =>
    axios.get(
      '/learn/app/clientapi/trainingclass/training/item/getTrainingItemExamTaskList.do',
      {
        params,
      }
    ),
}
